module.exports = __webpack_public_path__ + "img/whats-new-10_jp.c8765bd.jpg";